import { Expose } from "class-transformer";

export class CreateReportSectionDto {
  @Expose()
  title: string;

  @Expose()
  description?: string;

  @Expose()
  maximumFiles: number;

  @Expose()
  hasTextField?: boolean;

  @Expose()
  textFieldPlaceholder?: string;

  @Expose()
  reportTemplateId: string;
}
